import styled from 'styled-components'

export const UserMenuContentContainer = styled.ul`
    list-style-type: none;
    text-align: left;
`
